import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var RecordContactPerson = function (_a) {
    var cpName = _a.cpName, cpPhoneNumber = _a.cpPhoneNumber;
    return (_jsxs("div", { children: [_jsx("p", { children: cpName }), _jsx("p", { children: cpPhoneNumber })] }));
};
export default RecordContactPerson;
